// src/components/Profile/WishlistSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function WishlistSection({ wishlistItems, getImageUrl }) {
  return (
    <div className="profile-card card-animate">
      <div className="profile-header">
        <h3>My Wishlist</h3>
        <Link to="/wishlist" className="view-all-btn">View All</Link>
      </div>

      <div className="wishlist-preview">
        {wishlistItems.length > 0 ? (
          wishlistItems.slice(0, 3).map((item) => (
            <div key={item.wishlist_item_id} className="wishlist-item">
              <div className="wishlist-product">
                <img
                  src={getImageUrl(item.material?.image_swatch)}
                  alt={item.product_type?.name}
                  className="wishlist-thumb"
                />
                <div className="wishlist-info">
                  <h4>{item.product_type?.name}</h4>
                  <p className="text-sm text-gray-600" style={{ color: '#FFFFFF' }}>{item.material?.name}</p>
                  <span className="price">${parseFloat(item.prices?.total_price || 0).toFixed(2)}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">No items in wishlist</p>
        )}
      </div>

      {wishlistItems.length > 3 && (
        <Link to="/wishlist" className="view-more-link">
          +{wishlistItems.length - 3} more items
        </Link>
      )}
    </div>
  );
}